// extracted by mini-css-extract-plugin
export default {"container":"sidebar-header_container__wUWMN","company":"sidebar-header_company__xoOtX","service":"sidebar-header_service__nBR2q"};